export default {
  Colors: {
    primary: '#FFEBD9',
    text: '#E66767',
    background: '#FFF8F2',
    white: '#FFF',
    overlayColor: 'rgba(0, 0, 0, 0.8)'
  },
  fontSizes: {
    headingXl: '36px',
    headingL: '32px',
    headingM: '18px',
    bodyM: '16px',
    bodyS: '14px',
    body: '10px'
  },
  breakpoints: {
    mobile: '690px',
    tablet: '1079px'
  }
}
